export const getContextValues = (state: any, contextMethods: any) => {
  const {
    isMenuShown,
    selectedMenu,
    airlines,
    aircrafts,
    countries,
    airports,
    places,
    years,
    trips,
    layers,
    modes,
    routes,
    infoWindow
  } = state;
  const {
    toggleShowMenu,
    selectMenu,
    toggleCountrySelection,
    showAllCountries,
    hideAllCountries,
    toggleYearSelection,
    showAllYears,
    hideAllYears,
    changeMode,
    toggleLayerSelection,
    showAllLayers,
    hideAllLayers,
    toggleTripSelection,
    showAllTrips,
    hideAllTrips,
    showInfoWindow,
    hideInfoWindow
  } = contextMethods;

  return {
    isMenuShown,
    selectedMenu,
    airlines,
    aircrafts,
    countries,
    airports,
    places,
    years,
    trips,
    layers,
    modes,
    routes,
    infoWindow,
    // methods
    toggleShowMenu,
    selectMenu,
    toggleCountrySelection,
    showAllCountries,
    hideAllCountries,
    toggleYearSelection,
    showAllYears,
    hideAllYears,
    changeMode,
    toggleLayerSelection,
    showAllLayers,
    hideAllLayers,
    toggleTripSelection,
    showAllTrips,
    hideAllTrips,
    showInfoWindow,
    hideInfoWindow
  };
};

export const buildAirlinesObject = (airlines: any) => {
  const airlinesKeys = Object.keys(airlines);
  return airlinesKeys.map(key => {
    return {
      ...airlines[key],
      id: key,
      pastFlights: 0,
      futureFlights: 0,
      canceledFlights: 0
    };
  });
};

export const buildAircraftsObject = (aircrafts: any) => {
  const aircraftsKeys = Object.keys(aircrafts);
  return aircraftsKeys.map(key => {
    return {
      ...aircrafts[key],
      id: key,
      pastFlights: 0,
      futureFlights: 0,
      canceledFlights: 0
    };
  });
};

export const buildCountriesObject = (countries: any) => {
  const countriesKeys = Object.keys(countries);
  return countriesKeys.map(key => {
    return {
      ...countries[key],
      id: key,
      isVisible: true,
      isAvailable: false,
      places: [],
      airports: [],
      isPastCountry: true,
      isFutureCountry: true
    };
  });
};

export const buildAirportsObject = (jsonAirports: any) => {
  const airportsKeys = Object.keys(jsonAirports);
  return airportsKeys.map(key => {
    return {
      ...jsonAirports[key],
      id: key,
      isVisible: true,
      isAvailable: false,
      years: [],
      trips: [],
      isPastPlace: false,
      isFuturePlace: false
    };
  });
};

export const buildPlacesObject = (jsonPlaces: any) => {
  const placesKeys = Object.keys(jsonPlaces);
  return placesKeys.map(key => {
    return {
      ...jsonPlaces[key],
      id: key,
      isVisible: true,
      isAvailable: false,
      years: [],
      trips: [],
      isPastPlace: false,
      isFuturePlace: false
    };
  });
};

export const buildTripsObject = (jsonTrips: any, state: any) => {
  const {
    years: stateYears,
    airports: stateAirports,
    countries: stateCountries,
    places: statePlaces,
    airlines: stateAirlines,
    aircrafts: stateAircrafts
  } = state;

  const dateObject = new Date();
  const actualMonth = dateObject.getMonth() + 1;
  const actualDay = dateObject.getDate();
  const actualDate =
    dateObject.getFullYear() +
    "-" +
    (actualMonth < 10 ? "0" : "") +
    actualMonth +
    "-" +
    (actualDay < 10 ? "0" : "") +
    actualDay;

  const trips = jsonTrips.map((trip: any, idx: number) => {
    return {
      ...trip,
      id: idx,
      isVisible: true,
      isFiltered: true,
      isFutureTrip: trip.date[1] > actualDate
    };
  });

  const routes: any = [];

  trips.forEach((trip: any, idx: number) => {
    trip.routes &&
      trip.routes.forEach((jsonRoute: any) => {
        let isRouteCreated = false;
        routes.forEach((route: any) => {
          if (route.dep === jsonRoute.dep && route.arr === jsonRoute.arr) {
            isRouteCreated = true;
            route.counter++;
            route.trips.push(idx);
            if (jsonRoute.isCanceled) {
              route.canceledFlights++;
            } else {
              route.isVisible = true;
              if (trip.isFutureTrip) {
                route.futureFlights++;
              } else {
                route.pastFlights++;
              }
            }
          }
        });
        if (!isRouteCreated) {
          routes.push({
            dep: jsonRoute.dep,
            arr: jsonRoute.arr,
            counter: 1,
            isVisible: jsonRoute.isCanceled !== true,
            trips: [idx],
            pastFlights:
              jsonRoute.isCanceled !== true && !trip.isFutureTrip ? 1 : 0,
            futureFlights:
              jsonRoute.isCanceled !== true && trip.isFutureTrip ? 1 : 0,
            canceledFlights: jsonRoute.isCanceled ? 1 : 0
          });
        }
      });
  });

  const years = stateYears.map((year: any) => {
    const yearId = year.id.toString();
    const filteredTrips = trips.filter(
      (trip: any) =>
        trip.date[0].substring(0, 4) === yearId ||
        trip.date[1].substring(0, 4) === yearId
    );

    if (filteredTrips.length === 0) return year;

    return {
      ...year,
      trips: filteredTrips.map((trip: any) => trip.id)
    };
  });

  const airports = stateAirports.map((airport: any) => {
    const filteredTrips = trips.filter(
      (trip: any) =>
        trip.routes &&
        trip.routes.some(
          (route: any) => route.dep === airport.id || route.arr === airport.id
        )
    );

    if (filteredTrips.length === 0) return airport;

    return {
      ...airport,
      isAvailable: filteredTrips.some((trip: any) =>
        trip.routes.some(
          (route: any) =>
            route.isCanceled !== true &&
            (route.dep === airport.id || route.arr === airport.id)
        )
      ),
      years: years
        .filter((year: any) => {
          const yearId = year.id.toString();
          return filteredTrips.some(
            (trip: any) =>
              trip.date[0].substring(0, 4) === yearId ||
              trip.date[1].substring(0, 4) === yearId
          );
        })
        .map((year: any) => year.id),
      trips: filteredTrips.map((trip: any) => trip.id),
      isPastAirport: filteredTrips.some(
        (trip: any) =>
          !trip.isFutureTrip &&
          trip.routes.some(
            (route: any) =>
              route.isCanceled !== true &&
              (route.dep === airport.id || route.arr === airport.id)
          )
      ),
      isFutureAirport: filteredTrips.some(
        (trip: any) =>
          trip.isFutureTrip &&
          trip.routes.some(
            (route: any) =>
              route.isCanceled !== true &&
              (route.dep === airport.id || route.arr === airport.id)
          )
      ),
      isCanceledAirport: filteredTrips.some((trip: any) =>
        trip.routes.some(
          (route: any) =>
            route.isCanceled &&
            (route.dep === airport.id || route.arr === airport.id)
        )
      )
    };
  });

  const places = statePlaces.map((place: any) => {
    const filteredTrips = trips.filter((trip: any) =>
      trip.places.some((tripPlace: any) => tripPlace === place.id)
    );

    if (filteredTrips.length === 0) return place;

    return {
      ...place,
      isAvailable: true,
      years: years
        .filter((year: any) => {
          const yearId = year.id.toString();
          return filteredTrips.some(
            (trip: any) =>
              trip.date[0].substring(0, 4) === yearId ||
              trip.date[1].substring(0, 4) === yearId
          );
        })
        .map((year: any) => year.id),
      trips: filteredTrips.map((trip: any) => trip.id),
      isPastPlace: filteredTrips.some((trip: any) => !trip.isFutureTrip),
      isFuturePlace: filteredTrips.some((trip: any) => trip.isFutureTrip)
    };
  });

  const countries = stateCountries.map((country: any) => {
    const filteredAirports = airports.filter(
      (airport: any) => airport.isAvailable && airport.country === country.id
    );
    const filteredPlaces = places.filter(
      (place: any) => place.isAvailable && place.country === country.id
    );

    if (filteredAirports.length === 0 && filteredPlaces.length === 0)
      return country;

    const filteredTrips = trips.filter(
      (trip: any) =>
        trip.places.some((tripPlace: any) =>
          filteredPlaces.some(
            (filteredPlace: any) => filteredPlace.id === tripPlace.id
          )
        ) ||
        (trip.routes &&
          trip.routes.some((tripRoute: any) =>
            filteredAirports.some(
              (filteredAirport: any) =>
                filteredAirport.id === tripRoute.dep ||
                filteredAirport.id === tripRoute.arr
            )
          ))
    );

    return {
      ...country,
      isAvailable: true,
      airports: filteredAirports.map((airport: any) => airport.id),
      places: filteredPlaces.map((place: any) => place.id),
      isPastCountry: filteredTrips.some((trip: any) => !trip.isFutureTrip),
      isFutureCountry: filteredTrips.some((trip: any) => trip.isFutureTrip)
    };
  });

  const aircrafts = stateAircrafts.map((aircraft: any) => {
    let pastFlights = 0;
    let futureFlights = 0;
    let canceledFlights = 0;

    trips.forEach((trip: any) => {
      trip.routes &&
        trip.routes.forEach((route: any) => {
          if (
            route.type === aircraft.id &&
            trip.isFutureTrip &&
            route.isCanceled !== true
          )
            futureFlights++;
          if (
            route.type === aircraft.id &&
            !trip.isFutureTrip &&
            route.isCanceled !== true
          )
            pastFlights++;
          if (route.type === aircraft.id && route.isCanceled) canceledFlights++;
        });
    });

    if (pastFlights === 0 && futureFlights === 0 && canceledFlights === 0)
      return aircraft;

    return {
      ...aircraft,
      isAvailable: true,
      pastFlights,
      futureFlights,
      canceledFlights
    };
  });

  const airlines = stateAirlines.map((airline: any) => {
    let pastFlights = 0;
    let futureFlights = 0;
    let canceledFlights = 0;

    trips.forEach((trip: any) => {
      trip.routes &&
        trip.routes.forEach((route: any) => {
          if (
            route.airline === airline.id &&
            trip.isFutureTrip &&
            route.isCanceled !== true
          )
            futureFlights++;
          if (
            route.airline === airline.id &&
            !trip.isFutureTrip &&
            route.isCanceled !== true
          )
            pastFlights++;
          if (route.airline === airline.id && route.isCanceled)
            canceledFlights++;
        });
    });

    if (pastFlights === 0 && futureFlights === 0 && canceledFlights === 0)
      return airline;

    return {
      ...airline,
      isAvailable: true,
      pastFlights,
      futureFlights,
      canceledFlights
    };
  });

  return {
    trips,
    routes,
    years,
    airports,
    countries,
    places,
    airlines,
    aircrafts
  };
};

export const calculateVisibility = (state: any) => {
  const { layers, years, countries, modes } = state;

  const mode = modes.filter((mode: any) => mode.isSelected)[0].id;

  // calculation for airports
  const airports = state.airports.map((airport: any) => {
    const isLayerVisible = layers.filter(
      (layer: any) => layer.id === "airports"
    )[0].isVisible;

    const isAnyYearVisible = airport.years.some((year: any) =>
      years.some(
        (stateYear: any) => stateYear.id === year && stateYear.isVisible
      )
    );

    const isCountryVisible = countries.filter(
      (country: any) => country.id === airport.country
    )[0].isVisible;

    const isAnyTripVisible = airport.trips.some((trip: any) =>
      state.trips.some(
        (stateTrip: any) => stateTrip.id === trip && stateTrip.isVisible
      )
    );

    const isModeVisible =
      (mode === "past" && airport.isPastAirport) ||
      (mode === "future" && airport.isFutureAirport) ||
      (mode === "canceled" && airport.isCanceledAirport);

    const isVisible =
      isLayerVisible &&
      isAnyYearVisible &&
      isCountryVisible &&
      isAnyTripVisible &&
      isModeVisible;

    return {
      ...airport,
      isVisible
    };
  });

  // calculation for places
  const places = state.places.map((place: any) => {
    const isLayerVisible = layers.filter(
      (layer: any) => layer.id === "places"
    )[0].isVisible;

    const isAnyYearVisible = place.years.some((year: any) =>
      years.some(
        (stateYear: any) => stateYear.id === year && stateYear.isVisible
      )
    );

    const isCountryVisible = countries.filter(
      (country: any) => country.id === place.country
    )[0].isVisible;

    const isAnyTripVisible = place.trips.some((trip: any) =>
      state.trips.some(
        (stateTrip: any) => stateTrip.id === trip && stateTrip.isVisible
      )
    );

    const isModeVisible =
      (mode === "past" && place.isPastPlace) ||
      (mode === "future" && place.isFuturePlace);

    const isVisible =
      isLayerVisible &&
      isAnyYearVisible &&
      isCountryVisible &&
      isAnyTripVisible &&
      isModeVisible;

    return {
      ...place,
      isVisible
    };
  });

  // calculation for trips
  const trips = state.trips.map((trip: any) => {
    const yearStart = trip.date[0].substring(0, 4);
    const yearEnd = trip.date[1].substring(0, 4);
    const isAnyYearVisible = years.some((stateYear: any) => {
      const yearId = stateYear.id.toString();
      return (
        (yearId === yearStart && stateYear.isVisible) ||
        (yearId === yearEnd && stateYear.isVisible)
      );
    });

    const isFiltered = isAnyYearVisible;

    return {
      ...trip,
      isFiltered
    };
  });

  // calculation for routes
  const routes = state.routes.map((route: any) => {
    const isLayerVisible = layers.filter(
      (layer: any) => layer.id === "routes"
    )[0].isVisible;

    const filteredAirports = airports.filter(
      (airport: any) => airport.id === route.dep || airport.id === route.arr
    );

    const areAllCountriesVisible = countries
      .filter(
        (country: any) =>
          country.id === filteredAirports[0].country ||
          country.id === filteredAirports[1].country
      )
      .every((country: any) => country.isVisible);

    const isAnyTripVisible = route.trips.some((trip: any) =>
      trips.some(
        (stateTrip: any) =>
          stateTrip.id === trip &&
          stateTrip.isVisible &&
          stateTrip.isFiltered /*&&
          stateTrip.hidden !== true*/
      )
    );

    const isModeVisible =
      (mode === "past" && route.pastFlights > 0) ||
      (mode === "future" && route.futureFlights > 0) ||
      (mode === "canceled" && route.canceledFlights > 0);

    const isVisible =
      isLayerVisible &&
      areAllCountriesVisible &&
      isAnyTripVisible &&
      isModeVisible;

    return {
      ...route,
      isVisible
    };
  });

  return {
    ...state,
    airports,
    places,
    trips,
    routes
  };
};

export const generateEmptyYears = () => {
  const years: any = [];

  const actualDate = new Date();
  const actualYear = actualDate.getFullYear();

  for (let current = 2004; current <= actualYear; current++) {
    years.push({
      id: current,
      airports: [],
      places: [],
      trips: [],
      routes: [],
      isVisible: true
    });
  }

  return years;
};
